const LOCAL_API = "http://localhost:8080";
const LIVE_API = "https://api.clicklaw.ae/public";

function envApiUrl() {
  const vite =
    typeof import.meta !== "undefined" ? import.meta.env?.VITE_API_BASE_URL : undefined;
  const cra = typeof process !== "undefined" ? process.env.REACT_APP_API_BASE_URL : undefined;
  const value = vite || cra;
  return value ? String(value).replace(/\/+$/, "") : "";
}

function resolveBaseUrl() {
  const fromEnv = envApiUrl();
  if (fromEnv) return fromEnv;
  if (typeof window === "undefined") return LOCAL_API;

  const host = window.location.hostname;
  if (host === "localhost" || host === "127.0.0.1") return LOCAL_API;
  return LIVE_API;
}

export const BASE_URL = resolveBaseUrl();

export const STRIPE_PUBLISHABLE_KEY =
  (typeof import.meta !== "undefined" && import.meta.env?.VITE_STRIPE_PUBLISHABLE_KEY) ||
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY ||
  "pk_live_51UIYoIHuru1ajzSm8opBVPIUYcyy023gnvuOqd7AjC9CBKa6mtEZ0ysx91tb6Edjm0K0C3fC7rzJNZPiHQenAlAR0062erk2F3";

export const withBase = (path) => {
  if (!path) return null;
  if (/^https?:\/\//i.test(path)) return path;
  return `${BASE_URL}/${String(path).replace(/^\/+/, "")}`;
};
